<script>
import { onMount, tick } from "svelte";



export let value = ""
let readableValue = value
export let defaultValue = "inherit"
export let defaultLabel = "Default"
export let allowsEmpty = false

export let autosize = true

export let isValid = (value) => {
    return false
}

const isEmpty = (v) => {
    return readableValue.trim() == ""
}

const checkValue = () => {
    if (allowsEmpty) {
        if (!isValid(value)) {
            readableValue = defaultLabel
        }
    } else {
        if (!isValid(value) || isEmpty(value)) {
            readableValue = defaultLabel
        }
    }

}

var input

onMount(() => {
    checkValue()
})

export let focus = () => {

}

const onFocus = async () => {
    
    await tick();
    setTimeout(() => {
        document.execCommand('selectAll', false, null)
    }, 10.0)

    focus()

}

let tmp = document.createElement("DIV");

function stripHtml(html) {
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

$: {

    readableValue = stripHtml(readableValue)

    value = readableValue == defaultLabel ? defaultValue : readableValue
}

</script>

{#if autosize}
    <span bind:this={input} on:focus={onFocus} class:is-invalid={!isValid(value)} bind:innerHTML={readableValue} class="input inspector" on:blur={checkValue} contenteditable="true">{readableValue}</span>
{:else}
    <input bind:this={input} on:focus={onFocus} class:is-invalid={!isValid(value)} class="input inspector" on:blur={checkValue} bind:value={readableValue}/>
{/if}

<style>

.is-invalid {
    opacity: 0.5;
}

span.input {
    padding-left: 44px;
}


:global(input.inspector, select.inspector, .input.inspector) {
    background-color: rgba(0,0,0,0);
    border: 1px solid rgba(0,0,0,0);
    box-shadow: none;
    outline: none;
    color: var(--text-color);
    margin: 0px;
    padding: 3px 0px;
    border-radius: 0px;
    text-align: right;
    font-size: 0.9rem;
    min-width: 30px;
}

:global([contenteditable]) {
    -webkit-user-select: text;
    user-select: text;
}

:global(input.inspector:hover, select.inspector:hover, input.inspector:focus, select.inspector:focus) {

}

</style>